(()=>{
if(window.MOGA_TASKS_LOADED)return;
window.MOGA_TASKS_LOADED=true;

const KEY='moga_tasks_v7', SETTINGS='moga_task_settings_v7';
const byId=id=>document.getElementById(id);
const esc=v=>typeof escapeHtml==='function'?escapeHtml(v??''):String(v??'').replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
const norm=v=>String(v||'').trim().toLowerCase();
const now=()=>new Date().toISOString();
const today=()=>new Date().toISOString().slice(0,10);
const uid=()=>`task_${Date.now().toString(36)}_${Math.random().toString(36).slice(2,8)}`;
const premium=()=>!!window.MOGA_PLAN?.isPremium();

function load(){try{const x=JSON.parse(localStorage.getItem(KEY)||'[]');return Array.isArray(x)?x:[]}catch(e){return[]}}
function save(x){localStorage.setItem(KEY,JSON.stringify(x||[]));return x}
function settings(){try{return JSON.parse(localStorage.getItem(SETTINGS)||'{}')||{}}catch(e){return{}}}
function categories(){return settings().categories||['Bendra','Klientai','Pardavimai','Sandėlis','Pirkimai','Tiekėjai','Išlaidos','Apskaita','Kita']}
function priorityLabel(x){return({low:'ŽEMA',normal:'NORMALI',high:'AUKŠTA',urgent:'SKUBI'})[x]||'NORMALI'}
function relationLabel(t){return({invoice:'Sąskaita',purchase:'Pirkimas',product:'Prekė',client:'Klientas',supplier:'Tiekėjas',expense:'Išlaida',return:'Grąžinimas'})[t]||'—'}

let editingId=null;

function populateTaskCategories(selected=''){
  const e=byId('taskCategory');if(!e)return;
  e.innerHTML=categories().map(x=>`<option value="${esc(x)}">${esc(x)}</option>`).join('');
  e.value=categories().includes(selected)?selected:(categories()[0]||'Bendra');
}
function populateRelationTypes(selected=''){
  const e=byId('taskRelationType');if(!e)return;
  e.innerHTML='<option value="">Nesusieta</option>'+
    '<option value="invoice">Sąskaita</option><option value="purchase">Pirkimas</option><option value="product">Prekė</option><option value="client">Klientas</option><option value="supplier">Tiekėjas</option><option value="expense">Išlaida</option><option value="return">Grąžinimas</option>';
  e.value=selected||'';
}
function relationOptions(type){
  if(type==='invoice')return (typeof getTrackingInfo==='function'?getTrackingInfo():[]).map(x=>({value:x.no,label:`${x.no}${x.buyer?' · '+x.buyer:''}`}));
  if(type==='purchase')return (window.MOGA_PURCHASES?.orders?.()||[]).map(x=>({value:x.id,label:`${x.no}${window.MOGA_PURCHASES?.suppliers?(' · '+(window.MOGA_PURCHASES.suppliers().find(s=>s.id===x.supplierId)?.name||'')):''}`}));
  if(type==='product')return (window.MOGA_INVENTORY?.products?.()||[]).map(x=>({value:x.inventoryId,label:`${x.name}${x.sku?' · '+x.sku:''}`}));
  if(type==='client')return (typeof getClients==='function'?getClients():[]).map((x,i)=>({value:x.id||x.email||x.name||String(i),label:x.name||x.company||x.email||`Klientas ${i+1}`}));
  if(type==='supplier')return (window.MOGA_PURCHASES?.suppliers?.()||[]).map(x=>({value:x.id,label:x.name}));
  if(type==='expense')return (window.MOGA_EXPENSES?.load?.()||[]).map(x=>({value:x.id,label:`${x.date||''} · ${x.vendor||x.documentNo||'Išlaida'}`}));
  if(type==='return')return (window.MOGA_RETURNS?.load?.()||[]).map(x=>({value:x.id,label:`${x.date||''} · ${x.invoiceNo||''} · ${x.productName||''}`}));
  return[];
}
function refreshTaskRelationRef(selected=''){
  const type=byId('taskRelationType')?.value||'',e=byId('taskRelationRef');if(!e)return;
  const opts=relationOptions(type);
  e.innerHTML='<option value="">Pasirinkti...</option>'+opts.map(x=>`<option value="${esc(x.value)}">${esc(x.label)}</option>`).join('');
  e.disabled=!type;
  if(opts.some(x=>String(x.value)===String(selected)))e.value=selected;
}
window.refreshTaskRelationRef=refreshTaskRelationRef;


function ensureTaskViewUi(){
  if(!document.getElementById('mogaTaskViewStyle')){
    const st=document.createElement('style');
    st.id='mogaTaskViewStyle';
    st.textContent=`
      .task-icon.view{background:#f5a800!important;color:#111!important;border-color:#d89200!important}
      .task-view-modal{display:none;position:fixed;inset:0;z-index:10050;background:rgba(0,0,0,.72);backdrop-filter:blur(5px);align-items:center;justify-content:center;padding:18px}
      .task-view-modal.open{display:flex}
      .task-view-window{width:min(760px,96vw);max-height:92vh;overflow:hidden;border-radius:18px;background:#151515;border:1px solid #3b3b3b;box-shadow:0 30px 90px rgba(0,0,0,.58);display:flex;flex-direction:column}
      .task-view-head{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:16px 18px;border-bottom:2px solid transparent;border-image:linear-gradient(90deg,#ff8a00,#ff4f91) 1}
      .task-view-kicker{font-size:10px;font-weight:900;letter-spacing:1.2px;color:#ff9800;margin-bottom:4px}
      .task-view-head h3{margin:0;font-size:19px;color:#fff}
      .task-view-x{width:38px;height:38px;border-radius:50%;border:1px solid #555;background:#232323;color:#fff;font-size:23px;cursor:pointer}
      .task-view-body{padding:17px;overflow:auto}
      .task-view-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}
      .task-view-card{background:#1d1d1d;border:1px solid #383838;border-radius:12px;padding:11px 12px}
      .task-view-card.wide{grid-column:1/-1}
      .task-view-card span{display:block;font-size:10px;font-weight:800;color:#929292;text-transform:uppercase;letter-spacing:.4px;margin-bottom:5px}
      .task-view-card b,.task-view-card div{color:#fff;font-size:13px;line-height:1.45;word-break:break-word}
      .task-view-note{white-space:pre-wrap;min-height:62px}
      .task-view-section{grid-column:1/-1;margin-top:4px;padding-top:12px;border-top:1px solid #353535}
      .task-view-section-title{font-size:11px;font-weight:900;color:#ff9a18;letter-spacing:.6px;margin-bottom:8px}
      .task-view-related{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px}
      .task-view-related .task-view-card{background:#191919}
      .task-view-actions{padding:12px 16px;background:#202020;display:flex;gap:8px;justify-content:flex-end;border-top:1px solid #333}
      .task-view-actions button{border:1px solid #4a4a4a;border-radius:999px;background:#292929;color:#fff;padding:9px 15px;font-weight:900;cursor:pointer}
      .task-view-actions .gold{border:0;background:linear-gradient(90deg,#ff8a00,#ff4f91);color:#111}
      @media(max-width:640px){.task-view-grid,.task-view-related{grid-template-columns:1fr}}
    `;
    document.head.appendChild(st);
  }
  if(!document.getElementById('taskViewModal')){
    const modal=document.createElement('div');
    modal.id='taskViewModal';
    modal.className='task-view-modal premium-only screen-only';
    modal.innerHTML=`
      <div class="task-view-window" role="dialog" aria-modal="true">
        <div class="task-view-head">
          <div><div class="task-view-kicker">MOGA SF · UŽDUOTIS</div><h3 id="taskViewTitle">UŽDUOTIES INFORMACIJA</h3></div>
          <button class="task-view-x" onclick="closeTaskView()" title="Uždaryti">×</button>
        </div>
        <div id="taskViewBody" class="task-view-body"></div>
        <div class="task-view-actions">
          <button onclick="closeTaskView()">UŽDARYTI</button>
          <button id="taskViewEditBtn" class="gold">REDAGUOTI</button>
        </div>
      </div>`;
    modal.addEventListener('click',e=>{if(e.target===modal)closeTaskView()});
    document.body.appendChild(modal);
  }
}

function formatTaskDate(v){
  if(!v)return'—';
  try{
    const d=new Date(String(v).length===10?v+'T00:00:00':v);
    if(Number.isNaN(d.getTime()))return String(v);
    return d.toLocaleDateString('lt-LT');
  }catch(_){return String(v)}
}
function formatTaskDateTime(v){
  if(!v)return'—';
  try{
    const d=new Date(v);
    if(Number.isNaN(d.getTime()))return String(v);
    return d.toLocaleString('lt-LT');
  }catch(_){return String(v)}
}
function relationRecord(t){
  const type=t?.relationType,ref=t?.relationRef;
  if(!type||!ref)return null;
  try{
    if(type==='invoice'){
      const x=(typeof getTrackingInfo==='function'?getTrackingInfo():[]).find(v=>String(v.no)===String(ref));
      if(!x)return null;
      return {
        title:x.no||ref,
        fields:[
          ['Pirkėjas',x.buyer||'—'],
          ['Data',x.date||'—'],
          ['Suma',x.sum||x.received||'—'],
          ['Būsena',x.status||'—'],
          ['Mokėjimas',x.payment||'—'],
          ['Sekimo Nr.',x.trackingNumber||'—'],
          ['Pristatymo vieta',x.deliveryPlace||'—']
        ]
      };
    }
    if(type==='purchase'){
      const x=(window.MOGA_PURCHASES?.orders?.()||[]).find(v=>String(v.id)===String(ref));
      if(!x)return null;
      const supplier=(window.MOGA_PURCHASES?.suppliers?.()||[]).find(s=>String(s.id)===String(x.supplierId));
      return {
        title:x.no||ref,
        fields:[
          ['Tiekėjas',supplier?.name||x.supplierSnapshot?.name||'—'],
          ['Data',x.date||x.orderDate||x.createdAt||'—'],
          ['Numatoma gavimo data',x.expectedDate||x.expectedDeliveryDate||'—'],
          ['Būsena',x.status||'—'],
          ['Valiuta',x.currency||'EUR'],
          ['Apmokėta',x.paidAmount!==undefined?`${x.paidAmount} €`:'—'],
          ['Sekimo Nr.',x.trackingNo||x.trackingNumber||'—']
        ]
      };
    }
    if(type==='product'){
      const x=(window.MOGA_INVENTORY?.products?.()||[]).find(v=>String(v.inventoryId)===String(ref));
      if(!x)return null;
      return {title:x.name||ref,fields:[['SKU',x.sku||'—'],['Kategorija',x.category||'—'],['Pardavimo kaina',x.price!==undefined&&x.price!==''?`${x.price} €`:'—'],['Savikaina',x.cost!==undefined&&x.cost!==''?`${x.cost} €`:'—']]};
    }
    if(type==='client'){
      const list=typeof getClients==='function'?getClients():[];
      const x=list.find((v,i)=>String(v.id||v.email||v.name||i)===String(ref));
      if(!x)return null;
      return {title:x.name||x.company||x.email||ref,fields:[['El. paštas',x.email||'—'],['Telefonas',x.phone||'—'],['Adresas',x.address||'—']]};
    }
    if(type==='supplier'){
      const x=(window.MOGA_PURCHASES?.suppliers?.()||[]).find(v=>String(v.id)===String(ref));
      if(!x)return null;
      return {title:x.name||ref,fields:[['Įmonės kodas',x.companyCode||'—'],['PVM kodas',x.vatCode||'—'],['Kontaktas',x.contactName||'—'],['Telefonas',x.phone||'—'],['El. paštas',x.email||'—'],['Šalis',x.country||'—']]};
    }
    if(type==='expense'){
      const x=(window.MOGA_EXPENSES?.load?.()||[]).find(v=>String(v.id)===String(ref));
      if(!x)return null;
      return {title:x.vendor||x.documentNo||'Išlaida',fields:[['Data',x.date||'—'],['Dokumento Nr.',x.documentNo||'—'],['Suma',x.amount!==undefined?`${x.amount} €`:'—'],['Kategorija',x.category||'—'],['Mokėjimas',x.paymentMethod||x.payment||'—']]};
    }
    if(type==='return'){
      const x=(window.MOGA_RETURNS?.load?.()||[]).find(v=>String(v.id)===String(ref));
      if(!x)return null;
      return {title:x.invoiceNo||x.productName||'Grąžinimas',fields:[['Data',x.date||'—'],['SF Nr.',x.invoiceNo||'—'],['Prekė',x.productName||'—'],['Kiekis',x.qty??x.quantity??'—'],['Priežastis',x.reason||'—']]};
    }
  }catch(_){}
  return null;
}
function taskField(label,value,wide=false,extra=''){
  return `<div class="task-view-card${wide?' wide':''}"><span>${esc(label)}</span><div class="${extra}">${esc(value??'—')}</div></div>`;
}
function openTaskView(id){
  if(!premium())return;
  ensureTaskViewUi();
  const t=load().find(x=>String(x.id)===String(id));if(!t)return;
  const st=state(t),rel=relationRecord(t);
  let html='<div class="task-view-grid">';
  html+=taskField('Užduotis',t.title||'—',true);
  html+=taskField('Būsena',stateLabel(st));
  html+=taskField('Prioritetas',priorityLabel(t.priority));
  html+=taskField('Kategorija',t.category||'—');
  html+=taskField('Terminas',`${formatTaskDate(t.dueDate)}${t.dueTime?' · '+t.dueTime:''}`);
  html+=taskField('Sukurta',formatTaskDateTime(t.createdAt));
  html+=taskField('Atnaujinta',formatTaskDateTime(t.updatedAt));
  if(t.status==='done')html+=taskField('Įvykdyta',formatTaskDateTime(t.completedAt));
  html+=taskField('Pastabos',t.notes||'Pastabų nėra.',true,'task-view-note');
  if(t.relationType){
    html+=`<div class="task-view-section"><div class="task-view-section-title">SUSIETAS ĮRAŠAS · ${esc(relationLabel(t.relationType))}</div>`;
    if(rel){
      html+=`<div class="task-view-card wide" style="margin-bottom:8px"><span>Pavadinimas / numeris</span><b>${esc(rel.title)}</b></div><div class="task-view-related">`;
      html+=rel.fields.filter(([,v])=>v!==undefined&&v!==null&&String(v)!=='').map(([k,v])=>taskField(k,v)).join('');
      html+='</div>';
    }else{
      html+=`<div class="task-view-card wide"><span>Susiejimas</span><div>${esc(relationLabel(t.relationType))} · ${esc(t.relationRef||'—')}<br><small style="color:#888">Susieto įrašo detalių šiuo metu nepavyko rasti.</small></div></div>`;
    }
    html+='</div>';
  }
  html+='</div>';
  byId('taskViewTitle').textContent=t.title||'UŽDUOTIES INFORMACIJA';
  byId('taskViewBody').innerHTML=html;
  const edit=byId('taskViewEditBtn');
  if(edit)edit.onclick=()=>{closeTaskView();openTask(t.id)};
  byId('taskViewModal').classList.add('open');
}
function closeTaskView(){byId('taskViewModal')?.classList.remove('open')}
window.openTaskView=openTaskView;window.closeTaskView=closeTaskView;

function openTask(id=null){
  if(!premium())return alert('UŽDUOTYS prieinamos MOGA SF PREMIUM plane.');
  const modal=byId('taskModal');if(!modal)return;
  editingId=id;
  const t=id?load().find(x=>x.id===id):null;
  byId('taskModalTitle').textContent=t?'REDAGUOTI UŽDUOTĮ':'NAUJA UŽDUOTIS';
  byId('taskTitle').value=t?.title||'';
  byId('taskDueDate').value=t?.dueDate||today();
  byId('taskDueTime').value=t?.dueTime||'';
  byId('taskPriority').value=t?.priority||settings().defaultPriority||'normal';
  populateTaskCategories(t?.category||'');
  byId('taskNotes').value=t?.notes||'';
  populateRelationTypes(t?.relationType||'');
  refreshTaskRelationRef(t?.relationRef||'');
  byId('taskModal').classList.add('open');
  requestAnimationFrame(()=>byId('taskTitle')?.focus());
}
function closeTask(){byId('taskModal')?.classList.remove('open');editingId=null}
window.openTask=openTask;window.closeTask=closeTask;

function saveTask(){
  const title=byId('taskTitle')?.value.trim()||'';if(!title)return alert('Įrašyk užduoties pavadinimą.');
  const arr=load(),old=editingId?arr.find(x=>x.id===editingId):null;
  const obj={...(old||{}),id:old?.id||uid(),title,dueDate:byId('taskDueDate')?.value||'',dueTime:byId('taskDueTime')?.value||'',
    priority:byId('taskPriority')?.value||'normal',category:byId('taskCategory')?.value||'Bendra',notes:byId('taskNotes')?.value.trim()||'',
    relationType:byId('taskRelationType')?.value||'',relationRef:byId('taskRelationRef')?.value||'',
    status:old?.status||'todo',createdAt:old?.createdAt||now(),updatedAt:now(),completedAt:old?.completedAt||null};
  const i=arr.findIndex(x=>x.id===obj.id);if(i>=0)arr[i]=obj;else arr.push(obj);save(arr);closeTask();renderAll();window.renderOverview?.();window.MOGA_NOTIFICATIONS?.refresh?.();
}
window.saveTask=saveTask;

function completeTask(id){
  const arr=load(),t=arr.find(x=>x.id===id);if(!t)return;
  t.status='done';t.completedAt=now();t.updatedAt=now();save(arr);renderAll();window.renderOverview?.();window.MOGA_NOTIFICATIONS?.refresh?.();
}
function restoreTask(id){
  const arr=load(),t=arr.find(x=>x.id===id);if(!t)return;
  t.status='todo';t.completedAt=null;t.updatedAt=now();save(arr);renderAll();window.renderOverview?.();window.MOGA_NOTIFICATIONS?.refresh?.();
}
async function deleteTask(id){
  if(!(await MOGA_UI.confirm('Ištrinti užduotį visam laikui? Ji nebus palikta istorijoje.',{title:'Ištrinti užduotį?',danger:true,requireCheck:true,checkText:'Patvirtinu, kad noriu ištrinti šią užduotį',confirmText:'IŠTRINTI'})))return;
  save(load().filter(x=>x.id!==id));renderAll();window.renderOverview?.();window.MOGA_NOTIFICATIONS?.refresh?.();
}
window.completeTask=completeTask;window.restoreTask=restoreTask;window.deleteTask=deleteTask;

function state(t){
  if(t.status==='done')return'done';
  if(!t.dueDate)return'normal';
  const d=t.dueDate+(t.dueTime?`T${t.dueTime}:00`:'T23:59:59'),ts=new Date(d).getTime(),cur=Date.now();
  if(ts<cur)return'overdue';
  if(t.dueDate===today())return'today';
  return'normal';
}
function stateLabel(s){return({done:'ĮVYKDYTA',overdue:'VĖLUOJA',today:'ŠIANDIEN',normal:'AKTYVI'})[s]||'AKTYVI'}

function renderList(){
  const taskSearchEl=byId('taskSearch');if(taskSearchEl&&!taskSearchEl.placeholder)taskSearchEl.placeholder='Ieškoti...';
  const q=norm(byId('taskSearch')?.value),status=byId('taskStatusFilter')?.value||'todo',prio=byId('taskPriorityFilter')?.value||'all';
  let arr=load().filter(t=>{
    if(status!=='all'&&t.status!==status)return false;
    if(prio!=='all'&&t.priority!==prio)return false;
    return!q||norm([t.title,t.category,t.notes,t.relationType,t.relationRef].join(' ')).includes(q);
  }).sort((a,b)=>(a.status==='done')-(b.status==='done')||String(a.dueDate||'9999').localeCompare(String(b.dueDate||'9999'))||String(a.dueTime||'').localeCompare(String(b.dueTime||'')));
  const tb=byId('taskBody');if(!tb)return;
  tb.innerHTML=arr.length?arr.map(t=>{
    const st=state(t);
    return`<tr class="task-row ${st}">
      <td><div class="task-title">${esc(t.title)}</div><div class="task-mini">${esc(t.notes||'')}</div></td>
      <td>${esc(t.category||'—')}</td><td class="center"><span class="task-priority ${esc(t.priority)}">${priorityLabel(t.priority)}</span></td>
      <td>${esc(t.dueDate||'—')}${t.dueTime?`<div class="task-mini">${esc(t.dueTime)}</div>`:''}</td>
      <td class="center"><span class="task-state ${st}">${stateLabel(st)}</span></td>
      <td>${t.relationType?`<button class="task-link" onclick="MOGA_LINKS.open('${esc(t.relationType)}','${esc(t.relationRef)}')">${esc(relationLabel(t.relationType))}</button>`:'—'}</td>
      <td><div class="task-actions">
        ${t.status==='done'?`<button class="task-icon restore" onclick="restoreTask('${t.id}')" title="Grąžinti į aktyvias">↶</button>`:`<button class="task-icon done" onclick="completeTask('${t.id}')" title="Pažymėti įvykdyta">✓</button>`}
        <button class="task-icon view" onclick="openTaskView('${t.id}')" title="Peržiūrėti">◉</button>
        <button class="task-icon edit" onclick="openTask('${t.id}')" title="Redaguoti">✎</button>
        <button class="task-icon del" onclick="deleteTask('${t.id}')" title="Ištrinti">×</button>
      </div></td>
    </tr>`;
  }).join(''):'<tr><td colspan="7"><div class="purchase-empty">Užduočių nėra.</div></td></tr>';
  renderKpis();
}
function renderKpis(){
  const a=load(),active=a.filter(x=>x.status!=='done'),done=a.filter(x=>x.status==='done'),tod=active.filter(x=>x.dueDate===today()),over=active.filter(x=>state(x)==='overdue');
  const put=(id,v)=>{const e=byId(id);if(e)e.textContent=v};
  put('taskKpiActive',active.length);put('taskKpiToday',tod.length);put('taskKpiOverdue',over.length);put('taskKpiDone',done.length);
}
function renderAll(){if(!premium())return;renderList()}
window.renderTasks=renderAll;

function setPage(page){
  if(page!=='tasks')return false;
  if(!premium()){alert('UŽDUOTYS prieinamos MOGA SF PREMIUM plane.');return true}
  ['invoiceSheet','trackingSheet','statsSheet','warehouseSheet','purchaseSheet','expenseSheet','overviewSheet','accountingSalesSheet'].forEach(id=>{const e=byId(id);if(!e)return;if(id==='invoiceSheet')e.style.display='none';else e.classList.remove('active')});
  byId('taskSheet')?.classList.add('active');
  ['tabInvoice','tabTracking','tabStats','tabWarehouse','tabPurchases','tabExpenses','tabOverview','tabAccountingSales'].forEach(id=>byId(id)?.classList.remove('active'));
  byId('tabTasks')?.classList.add('active');renderAll();return true;
}
const base=window.switchPage;
window.switchPage=function(page){byId('taskSheet')?.classList.remove('active');byId('tabTasks')?.classList.remove('active');if(setPage(page))return;return typeof base==='function'?base(page):undefined};

document.addEventListener('keydown',e=>{if(e.key!=='Escape')return;if(byId('taskViewModal')?.classList.contains('open')){closeTaskView();return}if(byId('taskModal')?.classList.contains('open'))closeTask()});
window.addEventListener('moga:data-ready',()=>setTimeout(renderAll,0));window.addEventListener('moga:plan-change',()=>setTimeout(renderAll,0));
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{ensureTaskViewUi();renderAll()});else{ensureTaskViewUi();renderAll()}

window.MOGA_TASKS={load,render:renderAll,state,open:openTask};
})();
